import { render, staticRenderFns } from "./HostingDomain.vue?vue&type=template&id=4f4cfe62&"
import script from "./HostingDomain.vue?vue&type=script&lang=js&"
export * from "./HostingDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports